export default "__VITE_ASSET__T7rpQKbk__"